import styled from 'styled-components';
import media from 'styled-media-query';
import Button from 'components/Button';

export const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  padding-top: 37px;
  padding-bottom: 37px;

  ${media.lessThan('large')`
      padding: 2rem 1rem;
  `}

  @media only screen and (max-width: 1000px) {
    padding: 3rem 0rem;
    height: auto;
  }

  ${media.lessThan('small')`
      height: auto;
  `}
`;

export const ButtonSkip = styled(Button)`
  margin-top: 16px;
  align-self: flex-end;
  width: fit-content;
  max-width: 300px;

  padding: 10px 20px;

  margin: 20px auto 0 auto;
  display: block;
`;
